import { render, staticRenderFns } from "./DownloadsPublico.vue?vue&type=template&id=5dad6b62&scoped=true"
import script from "./DownloadsPublico.vue?vue&type=script&lang=js"
export * from "./DownloadsPublico.vue?vue&type=script&lang=js"
import style0 from "./DownloadsPublico.vue?vue&type=style&index=0&id=5dad6b62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dad6b62",
  null
  
)

export default component.exports